import { Doughnut } from 'react-chartjs-2';
import { Skeleton } from 'primereact/skeleton';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function CampaignRowAnalytics({ campaignDetails }) {
  const analytics = campaignDetails?.analytics || {};

  const total = analytics.total || 0;
  const sent = analytics.sent || 0;
  const delivered = analytics.delivered || 0;
  const read = analytics.read || 0;
  const failed = analytics.failed || 0;

  const successRate = total > 0 ? parseFloat((((total - failed) / total) * 100).toFixed(1)) : 0;

  const item = {
    datasets: [
      {
        label: 'Conversations',
        data: [sent, delivered, read, failed],
        backgroundColor: ['grey', '#FFE66D', '#C4E0A5', '#570000'],
        borderColor: ['transparent'],
      },
    ],
  };

  return (
    <div className="flex gap-2 align-items-center">
      <div
        className="flex border-circle relative justify-content-start"
        style={{
          width: '50px',
          height: '50px',
          borderColor: `#ecedf1`,
          borderWidth: '1px',
          borderStyle: 'solid',
        }}
      >
        <div
          className="absolute top-1"
          style={{
            width: '52px',
            height: '52px',
            top: '-7px',
            left: '-2px',
          }}
        >
          <Doughnut
            data={item}
            options={{
              plugins: {
                tooltip: { enabled: false },
              },
            }}
          />
        </div>
      </div>

      {(total || failed) && (
        <div className="pl-4 pr-2 flex justify-content-start" style={{ minWidth: '8ch' }}>
          {total - failed}/{total}
        </div>
      )}
    </div>
  );
}

export default CampaignRowAnalytics;
